import React from 'react';

const EuiIconMlCreateSingleMetricJob = props => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16a16 16 0 0 1-16 16zm0-30C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14A14 14 0 0 0 16 2z" />
    <path
      className="euiIcon__fillSecondary"
      d="M23 15h-6V9h-2v6H9v2h6v6h2v-6h6z"
    />
  </svg>
);

export const icon = EuiIconMlCreateSingleMetricJob;
